export default class CartItemsTableController {
    constructor($scope, $http, $location) {
        'ngInject';

        this.$scope = $scope;
        this.$http = $http;
        this.$location = $location;
    }
}